<template>
    <BaseDialog
        :is-open="isOpen"
        :size="Size.Small"
        @close="$emit('close')"
    >
        <BaseDialogTitle data-spec-class="password-edit-dialog__title">
            {{ title }}
        </BaseDialogTitle>
        <BaseDialogBody>
            <BasePasswordEditForm
                :item-id="itemId"
                :update-password="updatePassword"
                :validation-error="validationError"
                :is-updating="isUpdating"
                :min-length="minLength"
                @success="$emit('close')"
            />
        </BaseDialogBody>
    </BaseDialog>
</template>

<script setup lang="ts">
import { withDefaults, defineProps, defineEmits, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Size } from '@/types';
import BasePasswordEditForm from './BasePasswordEditForm.vue';
import BaseDialogTitle from './BaseDialogTitle.vue';
import BaseDialogBody from './BaseDialogBody.vue';
import BaseDialog from './BaseDialog.vue';

interface PasswordFields {
    password: string;
    password_confirmation: string;
}

const { t } = useI18n();

interface Props {
    isOpen?: boolean;
    itemId: string | number;
    updatePassword: (id: string | number, fields: PasswordFields) => Promise<void>;
    validationError?: Record<string, string[]> | null;
    isUpdating?: boolean;
    minLength?: number;
    title?: string;
}

const props = withDefaults(defineProps<Props>(), {
    isOpen: false,
    isUpdating: false,
    minLength: 8,
    title: '',
    validationError: null,
});

const title = computed(() => props.title || t('actions.editPassword'));

defineEmits(['close']);
</script>
